import * as React from 'react';

import { useQuery } from '@apollo/client';

import { AddToCartSettingsQuery } from '@notino/shared/definitions/types';

import { AddToCartButtonProvider } from '@sharedComponents/AddToCartButton/context';
import { getModalAfterAddToCart } from '@sharedComponents/AddToCartButton/getModalAfterAddToCart';
import getAddToCartSettings from '@sharedComponents/AddToCartButton/queries/addToCartSettings.graphql';

import { useProductDetailContext } from '../ProductDetailContext';

import { useIntegrateSwogo } from './useIntegrateSwogo';
import { useSwogoTracking } from './useSwogoTracking';

const SwogoScriptBase: React.FC = () => {
  useIntegrateSwogo();

  return <div id="swogo-bundle-1" className="swogo-box" />;
};

export const SwogoScript = () => {
  const { currentVariant, product } = useProductDetailContext();
  const { data } = useQuery<AddToCartSettingsQuery>(getAddToCartSettings);
  const { trackProductsAdded, trackProductsFailed } = useSwogoTracking();

  if (!data) {
    return null;
  }

  return (
    <AddToCartButtonProvider
      product={{
        ...currentVariant,
        masterId: product.id,
      }}
      count={0}
      showAddToCartModal={true}
      onProductAdded={trackProductsAdded}
      onProductAddFailed={trackProductsFailed}
      getModalAfterAddToCart={getModalAfterAddToCart}
    >
      <SwogoScriptBase />
    </AddToCartButtonProvider>
  );
};
